import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomThDatePipe } from './custom-th-date.pipe';

@NgModule({
  declarations: [CustomThDatePipe],
  imports: [CommonModule],
  exports: [CustomThDatePipe],
})
export class CustomThDateModule {}
